import { EAlertSeverity, EAppointmentStatus, ERiskLevel} from '../types';

export const RISK_LEVEL_COLORS: Record<ERiskLevel, string> = {
  [ERiskLevel.LOW]: 'var(--color--ocean-green-700)',
  [ERiskLevel.MEDIUM]: 'var(--color--yellow-700)',
  [ERiskLevel.HIGH]: 'var(--color--red-600)',
};

export const RISK_LEVEL_BG_COLORS: Record<ERiskLevel, string> = {
  [ERiskLevel.LOW]: 'var(--color--ocean-green-90)',
  [ERiskLevel.MEDIUM]: 'var(--color--yellow-100)',
  [ERiskLevel.HIGH]: 'var(--color--red-100)',
};

export const RISK_LEVEL_THERMOMETER_MARKER_PERCENT: Record<ERiskLevel, number> = {
  [ERiskLevel.LOW]: 82,
  [ERiskLevel.MEDIUM]: 50,
  [ERiskLevel.HIGH]: 28,
};

export type TCreditAlertType = 'critical' | 'success' | 'warn';

export const ALERT_TYPE_BY_SEVERITY: Record<EAlertSeverity, TCreditAlertType> = {
  [EAlertSeverity.DANGER]: 'critical',
  [EAlertSeverity.SUCCESS]: 'success',
  [EAlertSeverity.WARNING]: 'warn',
  [EAlertSeverity.INFO]: 'warn',
};

export const GAUGE_ARC_COLORS: Record<ERiskLevel, string> = {
  [ERiskLevel.LOW]: '#1A9171',
  [ERiskLevel.MEDIUM]: '#F2C135',
  [ERiskLevel.HIGH]: '#CA3351',
};

export const RISK_BADGE_CLASSES: Record<ERiskLevel, string> = {
  [ERiskLevel.LOW]: 'risk-badge ez-badge--success-subtle',
  [ERiskLevel.MEDIUM]: 'risk-badge ez-badge--warning-subtle',
  [ERiskLevel.HIGH]: 'risk-badge ez-badge--error-subtle',
};

export const PROBABILITY_PERCENT_BADGE_CLASSES: Record<ERiskLevel, string> = {
  [ERiskLevel.LOW]: 'probability-chip',
  [ERiskLevel.MEDIUM]: 'probability-chip ez-badge--warning-solid',
  [ERiskLevel.HIGH]: 'probability-chip ez-badge--error-solid',
};

type EzEmptyCardColor = 'default' | 'green' | 'gray' | 'yellow' | 'red' | 'petroleum';

export const PROBABILITY_CARD_COLORS: Record<ERiskLevel, EzEmptyCardColor> = {
  [ERiskLevel.LOW]: 'green',
  [ERiskLevel.MEDIUM]: 'yellow',
  [ERiskLevel.HIGH]: 'red',
};

export const PROBABILITY_CARD_UNAVAILABLE_COLOR: EzEmptyCardColor = 'petroleum';
export const PROBABILITY_PERCENT_BADGE_UNAVAILABLE_CLASS = 'probability-chip ez-badge--disabled-solid';

export const GAUGE_COLOR_ZONES: Array<{ from: number; to: number; color: string }> = [
  { from: 0, to: 0.3, color: 'var(--color--red-400)' },
  { from: 0.3, to: 0.5, color: 'var(--color--red-600)' },
  { from: 0.5, to: 0.7, color: 'var(--color--yellow-400)' },
  { from: 0.7, to: 1.0, color: 'var(--color--ocean-green-400)' },
];

export const GAUGE_GEOMETRY = {
  centerX: 110,
  centerY: 110,
  radius: 82,
  strokeWidth: 28,
  startAngle: -180,
  endAngle: 0,
  needleOffset: 8,
  viewBox: '0 0 220 124',
};

export const SCORE_CHART_COLOR = 'var(--color--ocean-green-600)';

export interface IAppointmentBadgeConfig {
  className: string;
  size: 'medium' | 'extra-large' | 'large' | 'small-medium' | 'small' | 'extra-small';
}

export const APPOINTMENT_STATUS_BADGE_CONFIG: Record<EAppointmentStatus, IAppointmentBadgeConfig> = {
  [EAppointmentStatus.HEALTHY]: {
    className: 'appointment-status-badge ez-badge--success-subtle',
    size: 'small-medium',
  },
  [EAppointmentStatus.ATTENTION]: {
    className: 'appointment-status-badge ez-badge--error-solid',
    size: 'medium',
  },
};
